// src/api/authApi.js
import http from './http';

const API_URL = '/api/auth';

export const login = (data) => http.post(`${API_URL}/login`, data);

export const register = (data) => http.post(`${API_URL}/register`, data);

// updated to send JSON body instead of params
export const bootstrapAdmin = (data) => http.post(`${API_URL}/bootstrap-admin`, data);

export const forgotPassword = (email) => 
  http.post(`${API_URL}/forgot-password`, null, { params: { email } });

export const resetPassword = (token, newPassword) =>
  http.post(`${API_URL}/reset-password`, null, { params: { token, newPassword } });